import styled from "styled-components";
const HeaderImpl = styled("header")(
  {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit",
    flex: "0 0 auto",
    marginBottom: "auto",
    position: "relative",
    width: "100%",
    zIndex: 1
  },
  ({ theme, $border }) => $border ? {
    borderBottom: `1px solid ${theme.borderColor}`
  } : void 0,
  ({ $shadow }) => $shadow ? {
    boxShadow: "0 0 8px rgba(0,0,0,0.05)"
  } : void 0
);
export {
  HeaderImpl
};
